export default {"src":"/_next/static/media/tick.bc62d062.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};